import cx from 'classnames';

import {AnimatedText, Icon, NumberTicker, Text} from '#component/base';
import {ModalRoot, ModalTrigger} from '#component/base/Modal';
import {LifestyleScoreInfoModal} from '#component/modal';
import {Hero, KitRegisteredPill, LifestyleMeter} from '#component/partial';
import {Transition} from '#component/util';
import {pageSlideInKeyframe} from '#style/keyframes.css';
import {sprinkles} from '#style/sprinkles';
import {getLifestyleScoreTitle} from '#util/lifestyleScore';

import {HeaderProps} from './Header.types';

import * as css from './Header.css';

export const Header = ({
  hasActiveSubscription = false,
  lifestyleScore = 0,
  maxLifestyleScore = 100,
  registeredDate,
  ...otherProps
}: HeaderProps) => (
  <Hero variant="ecruWhite" {...otherProps}>
    <div className={sprinkles({layout: 'grid', items: 'center', pT: [80, 128]})}>
      <div
        className={sprinkles({
          colStart: [1, 1, 2],
          colSpan: [4, 8, 10],
          flex: 'flex',
          dir: 'col',
          gap: 128,
          w: 'full',
        })}>
        <Transition
          appear
          show
          className={cx(
            sprinkles({
              content: 'between',
              dir: ['colReverse', 'row'],
              flex: 'flex',
              gap: [32, 128, 192],
              items: 'start',
              pos: 'relative',
              z: 1,
            }),
            pageSlideInKeyframe,
          )}>
          <div className={css.rating}>
            <ModalRoot>
              <h1>
                <AnimatedText as="span" color="deepBurgundy" variant="heading2">
                  {`Your current lifestyle is ${getLifestyleScoreTitle(lifestyleScore)}`}
                </AnimatedText>

                <ModalTrigger className={sprinkles({mL: 8})}>
                  <Icon
                    aria-label="Learn more about Lifestyle Scores"
                    color="eggplantDark"
                    name="Info"
                    size="normal"
                  />
                </ModalTrigger>
              </h1>

              <LifestyleScoreInfoModal />
            </ModalRoot>

            <KitRegisteredPill
              className={sprinkles({self: 'start'})}
              registeredDate={registeredDate}
            />
          </div>

          <Text className={sprinkles({flex: 'flex', gap: 4})} fontWeight="light">
            <NumberTicker appear className={css.lifestyleScore} color="deepBurgundy">
              {lifestyleScore}
            </NumberTicker>

            <Text className={sprinkles({pT: 8})} color="inherit" variant="bodyXLarge">
              {`/${maxLifestyleScore}`}
            </Text>
          </Text>
        </Transition>

        <LifestyleMeter
          maxValue={maxLifestyleScore}
          value={lifestyleScore}
          withGlow
          withHighlight
        />
      </div>
    </div>
  </Hero>
);
